import { TypographyProps } from "@commonlibs";
import type { FullNumber } from "common/models/number/number";
import { FiatCurrency } from "common/models/currencies/currencies.types";

export type AppCurrency = FiatCurrency | "nativeToken";

export type BalanceAction = "display" | "add" | "round" | "less";

export type FormatOptions = "days" | "years";

export enum BalanceActions {
    DISPLAY = "display",
    ADD = "add",
    ROUND = "round",
    LESS = "less",
}

export interface BalanceThreshold {
    value: number;
    decimals: number;
}

export interface BalanceProps extends Omit<TypographyProps, "children"> {
    balance: FullNumber;
    units?: AppCurrency | string;
    unitsPosition?: "left" | "right";
    action?: BalanceAction;
    options?: Intl.NumberFormatOptions;
    isLoading?: boolean;
    thresholds?: UseFormatBalanceParams["thresholds"];
    minimumFallbackDisplay?: UseFormatBalanceParams["minimumFallbackDisplay"];
    formatter?: FormatOptions;
}

export interface FormatBalanceOptions {
    units?: BalanceProps["units"];
    unitsPosition?: BalanceProps["unitsPosition"];
    action?: BalanceAction;
}

export interface UseFormatBalanceParams extends FormatBalanceOptions {
    thresholds?: BalanceThreshold[];
    numberFormatOptions?: Omit<Intl.NumberFormatOptions, "useGrouping">;
    /**
     * It can be a string or a function that returns a string.
     * If is a string it will be used as the minimum fallback display. Ej: "0.000001"
     * If is a function it will be called with the balance as a parameter and it should return a string. Ej: (balance) => "1 Sat"
     */
    minimumFallbackDisplay?: string | ((balance: number | string | bigint) => string);
    formatter?: FormatOptions;
}

export type BalanceRootProps = Pick<BalanceProps, "variant">;
